<agr-page-detail [pageTitle]="getTitle()" data-test="create-feed-advice" (backAction)="back()">
  <ng-container actions>
    <button
      type="submit"
      mat-flat-button
      color="accent"
      (click)="save()"
      data-test="feed-advice__save-button"
    >
      <mat-icon>save</mat-icon>
      {{ getButtonText() }}
    </button>
  </ng-container>

  <div
    class="spacing--margin-horizontal spacing--margin-top"
    *ngIf="(isLoading$ | async) === false && feedAdvice$ | async"
  >
    <button
      *ngIf="!isReferenceFeedAdvice"
      mat-button
      class="button--text float-right"
      (click)="openPriceSettings()"
      data-test="feed-advice__pricesettings-button"
    >
      <mat-icon class="material-icons-outlined">settings</mat-icon>
      {{ 'price-settings.title' | translate }}
    </button>
    <h3>{{ 'create-feed-advice.properties.name' | translate }}</h3>
    <mat-form-field class="flex__child--auto">
      <input
        matInput
        required
        placeholder="{{ 'create-feed-advice.properties.name' | translate }}"
        data-test="create-feed-advice__feedadvice-name"
        [(ngModel)]="advice.name"
        #name="ngModel"
      />
    </mat-form-field>
    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="validation-error">
      <div *ngIf="name.errors?.['required']">
        {{ 'feed-advice-detail.validation-error.description.feedadvice-name' | translate }}
      </div>
    </div>

    <app-feed-advice-settings
      [isReferenceFeedAdvice]="isReferenceFeedAdvice"
      [locations]="advice.locationIds"
      [properties]="feedAdviceProperties"
      (settingsChanged)="changeFeedAdviceSettings($event)"
    >
    </app-feed-advice-settings>

    <h3>{{ 'create-feed-advice.scheme.remarks' | translate }}</h3>
    <div class="remarks-panel">
      <textarea
        class="text--small remarks-field"
        label="remarks"
        rows="3"
        placeholder="{{ 'create-feed-advice.scheme.remarks-placeholder' | translate }}"
        data-test="feed-advice__remarks"
        [(ngModel)]="advice.description"
      ></textarea>
    </div>
  </div>

  <div
    class="spacing--margin-horizontal spacing--margin-top"
    *ngIf="(isLoading$ | async) === false && feedAdvice$ | async"
  >
    <ng-container class="table-container" *ngIf="products$ | async">
      <app-feed-advice-table
        [isEditMode]="true"
        [showLysineColumn]="showLysine"
        [showEnergyColumn]="showEnergy"
        [showDosatorColumn]="showDosator"
        [feedAdviceType]="feedAdviceType"
        [isReferenceFeedAdvice]="false"
        [tableScheme]="tableScheme"
        [products]="products$ | async"
        [feedingType]="advice.feedingType"
      ></app-feed-advice-table>
    </ng-container>
  </div>
</agr-page-detail>
